import { render, staticRenderFns } from "./jdTips.vue?vue&type=template&id=080d99df&scoped=true"
import script from "./jdTips.vue?vue&type=script&lang=js"
export * from "./jdTips.vue?vue&type=script&lang=js"
import style0 from "./jdTips.vue?vue&type=style&index=0&id=080d99df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d99df",
  null
  
)

export default component.exports